import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SHOW_ERROR':
      return action.error;

    case 'LIVEINTERVIEW_REVIEW_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SHOW_LOADING':
      return action.loading;

    case 'LIVEINTERVIEW_REVIEW_SHOW_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SHOW_SUCCESS':
      return action.retrieved;

    case 'LIVEINTERVIEW_REVIEW_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export function eventSource(state = null, action) {
  switch (action.type) {
    case 'LIVEINTERVIEW_REVIEW_SHOW_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({ error, loading, retrieved, eventSource });
